import { useId } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@shared/components';
import type { QuoteLineView } from '../../utils/quoteSummaryLines';
import { QuoteLinesTable } from './QuoteLinesTable';

interface Props {
    lines: QuoteLineView[];
}

export function OptionalExtrasPanel({ lines }: Props) {
    const headingId = useId();

    if (lines.length === 0) {
        return null;
    }

    return (
        <Card>
            <CardHeader>
                <CardTitle>
                    <span id={headingId}>Optional Extras</span>
                </CardTitle>
            </CardHeader>
            <CardContent>
                <section aria-labelledby={headingId}>
                    <QuoteLinesTable title="Optional Extras" lines={lines} emptyMessage="No optional extras on this quote." />
                </section>
            </CardContent>
        </Card>
    );
}
